namespace GeniuzPOS.InitialData {
    export enum PosFg {
        alltimedy = 0,
        chtime = 1
    }
    Serenity.Decorators.registerEnumType(PosFg, 'GeniuzPOS.InitialData.PosFg');
}
